exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "#power-bi {\n  margin: 0;\n  padding: 0;\n  overflow: hidden;\n  height: 100%;\n  width: 100%;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/less-loader/dist/cjs.js!./src/styles/pages/home/index.less
// module id = 2719
// module chunks = 0